var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('mapbox'),_c('cabecalho'),_c('div',{staticClass:"conteudo",attrs:{"id":"conteudo-wraper"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }